import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-end',
    transition: 'all 100ms ease-in-out',
  },
  child: {
    marginTop: 15,
    backgroundColor: theme.palette.divider,
    width: '60%',
    borderRadius: theme.shape.borderRadius * 2,
    borderBottomRightRadius: 0,
    padding: 15,
    paddingBottom: 12,
    '& h4': {
      color: theme.palette.primary.main,
      borderBottom: `1px solid ${theme.palette.hover2}`,
      paddingBottom: 5,
      marginBottom: 7,
    },
    '& p': {
      color:
        theme.palette.type === 'dark' ? '#fff' : theme.palette.text.primary,
    },
    '@media (min-width: 1441px)': {
      width: '45%',
    },
  },
  actions: {
    marginTop: 15,
    marginRight: 5,
    width: 35,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  },
  bookmarked: {
    marginTop: 22,
    marginRight: 14,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    transition: 'all 100ms ease-in-out',
  },
}))

export default useStyles
